import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { AxiosResponse } from "axios";
import { TransportCost, TransportCostTotal } from "./models-service";
import { exportToExcelFile } from "@/utils/excel";
import { convertPeriodsListToMonthArray } from "@/utils/periods";
import BalanceService from '@/services/balance-service';

export const route_ns = `transport_cost`;
export const route_ns_total = `total_transport_cost`;
export const route_transport = `transport/costs`;

class TransportCostsInputService {
  public crud = base_ds.getBaseCrud(route_ns);

  public async getWithFilter(ids: String[], id_facility: number, periods: String[]): Promise<TransportCost[]> {
    const url = `${route_ns}?filter=[["id_cut","in",${JSON.stringify(ids)}],"and",["id_eco_facility","=","${id_facility}"],"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async save(pack: TransportCost[]) {
    return await request({
      url: route_ns,
      method: "post",
      data: {data: pack},
    });
  }

  public async delete(list: TransportCost[]) {
    return await request({
      url: route_ns,
      method: "delete",
      data: {data: list},
    });
  }

  public async getTotalWithFilter(ids: String[], id_facility: number, periods: String[]): Promise<TransportCostTotal[]> {
    const url = `${route_ns_total}?filter=[["id_cut","in",${JSON.stringify(ids)}],"and",["id_eco_facility","=","${id_facility}"],"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async getChangedTotal(id_cut: string, id_facility: number, blocks: string[], periods: String[]): Promise<TransportCostTotal[]> {
    let is_total = `["block","in",${JSON.stringify(blocks)}]`;
    if (blocks.includes('total')) {
      is_total = `[["block","in",${JSON.stringify(blocks)}],"or",["is_total","=","true"]]`;
    }
    const url = `${route_ns_total}?filter=[["id_cut","=","${id_cut}"],"and",["id_eco_facility","=","${id_facility}"],"and",${is_total},"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async saveTotal(pack: TransportCostTotal[]) {
    return await request({
      url: route_ns_total,
      method: "post",
      data: {data: pack},
    });
  }

  public async exportToExcel(data: any, filename: string | null = null) {
    await exportToExcelFile(data, route_ns_total, filename);
  }

  public async getTransportWithFilter(
    id_cut: string | null,
    heat_node_ids: number[],
    periods: string[]
  ) {
    
    let filter: any[] = []
    if(BalanceService.current.show_pao_tplus){
      filter = [
      ["id_cut", "=", id_cut],
      "and",
      ["month", "in", convertPeriodsListToMonthArray(periods)],
    ];
  } else {
    
      filter = [
      ["id_cut", "=", id_cut],
      "and",
      ["heat_node_id", "in", heat_node_ids],
      "and",
      ["month", "in", convertPeriodsListToMonthArray(periods)],
    ];
  }
    const url = `${route_transport}?filter=${encodeURIComponent(JSON.stringify(filter))}`;
    const { data } = await request({
      url,
      method: "get",
    });

    return data ?? [];
  }

  public async getGroupedTransportWithFilter(
    id_cut: string | null,
    heat_node_ids: number[],
    periods: string[],
    grouped: string[],
  ) {

    const filter = [
      ["id_cut", "=", id_cut],
      "and",
      ["heat_node_id", "in", heat_node_ids],
      "and",
      ["month", "in", convertPeriodsListToMonthArray(periods)],
    ];
    const url = `${route_transport}/grouped?filter=${encodeURIComponent(JSON.stringify(filter))}`;
    const { data } = await request({
      url,
      method: "post",
      data: {object_ids: grouped},
    });

    return data ?? [];
  }

}

export default new TransportCostsInputService();
